import React from 'react';
import { Field, useField } from 'formik';
import { FormHelperText, InputLabel, Typography } from '@mui/material';
import { cx } from '../../helpers/global';

interface Props {
  name: string;
  label: string;
  placeholder: string | undefined;
  helperText?: string;
}

export default function TextareaInput({
  name,
  label,
  placeholder,
  helperText,
}: Props) {
  const [, { error, touched }, { setTouched }] = useField(name);
  const isError = touched && !!error;
  const onBlur = React.useCallback(() => {
    setTouched(true);
  }, [setTouched]);
  return (
    <div style={{ width: '100%' }}>
      <div className={cx('input', isError && 'error')}>
        <InputLabel htmlFor={name}>
          <Typography variant="h5">{label}</Typography>
        </InputLabel>
        <Field
          id={name}
          as="textarea"
          name={name}
          placeholder={placeholder}
          onBlur={onBlur}
        />
      </div>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </div>
  );
}
